/* src/app/core/components/menu/sub-menu/sub-menu.component.scss */
.list-group li {
  width: 12.5rem;
}
.list-group li i {
  color: gold;
}
.sub-menu {
  transition: transform 0.3s ease-in-out;
  background-color: white;
  height: 100%;
}
.sub-menu ul.list-group li {
  border: none;
  border-radius: 0;
  font-size: 0.9em;
}
.sub-menu ul.list-group li.active {
  background-color: #3e53a4;
  color: white;
}
.sub-menu > div {
  padding: 0;
}
.hide {
  transform: translateX(-500px);
  transition: transform 0.3s ease-in-out;
  width: 0;
}
.list-group-item:hover {
  background-color: #5f74c1;
  color: white;
}
.list-group-item:hover i {
  color: white;
}
/*# sourceMappingURL=sub-menu.component.css.map */
